function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("react"), require("d3")) : "function" == typeof define && define.amd ? define(["react", "d3"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["tns-reports-ran"] = e(require("react"), require("d3")) : t["tns-reports-ran"] = e(t.react, t.d3);
}(self, function (t, e) {
  return function () {
    "use strict";

    var n = {
      990: function _(t) {
        t.exports = e;
      },
      156: function _(e) {
        e.exports = t;
      }
    },
        r = {};

    function a(t) {
      var e = r[t];
      if (void 0 !== e) return e.exports;
      var i = r[t] = {
        exports: {}
      };
      return n[t](i, i.exports, a), i.exports;
    }

    a.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return a.d(e, {
        a: e
      }), e;
    }, a.d = function (t, e) {
      for (var n in e) {
        a.o(e, n) && !a.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, a.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, a.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var i = {};
    return function () {
      a.r(i), a.d(i, {
        TNSReportsRAN: function TNSReportsRAN() {
          return e;
        }
      });
      var t = {};
      a.r(t), a.d(t, {
        HorizontalChart: function HorizontalChart() {
          return d;
        },
        Pies: function Pies() {
          return u;
        },
        VerticalChart: function VerticalChart() {
          return y;
        }
      });
      var e = {};
      a.r(e), a.d(e, {
        AvailableNutrients: function AvailableNutrients() {
          return t;
        },
        CationRatios: function CationRatios() {
          return C;
        }
      });
      var n = a(156),
          r = a.n(n),
          o = a(990);

      function l(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }

        return r;
      }

      function s(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      var u = function () {
        function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.data = e, this.availableColor = n.availableColor, this.unavailableColor = n.unavailableColor, this.scale = n.scale, this.radius = n.radius, this.labelPadding = n.labelPadding || 20, this.transitionDuration = n.transitionDuration;
        }

        var e, n;
        return e = t, (n = [{
          key: "availabilityData",
          value: function value() {
            var t = this;
            return this.data.map(function (e) {
              return t.nutrientData(e);
            });
          }
        }, {
          key: "nutrientData",
          value: function value(t) {
            var e,
                n = this,
                r = {
              name: t.name,
              pieData: []
            };
            return null == t.available ? r.pieData.push({
              value: 100,
              color: this.unknownColor,
              unknown: !0
            }) : 100 == t.available ? (e = Array(8), function (t) {
              if (Array.isArray(t)) return l(t);
            }(e) || function (t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return l(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(t, e) : void 0;
              }
            }(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()).forEach(function () {
              r.pieData.push({
                value: 12.5,
                color: n.availableColor,
                available: !0
              });
            }) : r.pieData.push({
              value: t.available,
              color: this.availableColor,
              available: !0
            }, {
              value: 100 - t.available,
              color: this.unavailableColor,
              available: !1
            }), r;
          }
        }, {
          key: "groupOn",
          value: function value(t) {
            var e = this,
                n = o.pie().value(function (t) {
              return t.value;
            }).sort(null),
                r = t.selectAll("g.nutrient-pie").data(this.availabilityData()).join("g").attr("class", "nutrient-pie"),
                a = o.local(),
                i = o.local(),
                l = this.availableColor,
                s = this.unavailableColor;
            return r.selectAll("path").data(function (t) {
              return a.set(this, "0px"), i.set(this, "white"), t.pieData.length > 0 && (t.pieData.length > 1 && a.set(this, "2px"), t.pieData.every(function (t) {
                return t.available;
              }) ? i.set(this, o.color(l).brighter(.3).formatHex()) : t.pieData.every(function (t) {
                return !t.available;
              }) && i.set(this, o.color(s).brighter(.3).formatHex())), n(t.pieData);
            }).join("path").attr("fill", function (t) {
              return t.data.color;
            }).attr("stroke", function () {
              return i.get(this);
            }).style("stroke-width", function () {
              return a.get(this);
            }).transition().ease(o.easeCircle).duration(this.transitionDuration).attrTween("d", function (t) {
              var n = o.arc().innerRadius(0).outerRadius(e.radius),
                  r = o.interpolate({
                startAngle: 0,
                endAngle: 0
              }, t);
              return function (t) {
                return n(r(t));
              };
            }), r.selectAll("text.label").data(function (t) {
              return [t.name];
            }).join("text").attr("class", "label").attr("text-anchor", "middle").attr("y", this.radius + this.labelPadding).style("font-size", "1rem").style("font-weight", "bold").style("letter-spacing", "0.05rem").text(function (t) {
              return t;
            }), r;
          }
        }, {
          key: "drawOverlayText",
          value: function value(t) {
            t.selectAll("text.unknown").data(function (t) {
              return [t.pieData];
            }).join("text").attr("class", "unknown").attr("text-anchor", "middle").style("dominant-baseline", "middle").style("font-size", "2rem").style("fill", "#888888").text(function (t) {
              return 1 == t.length && t[0].unknown ? "?" : "";
            }).style("fill-opacity", 0).transition().duration(2 * this.transitionDuration).style("fill-opacity", 1), t.selectAll("text.all-available").data(function (t) {
              return [t.pieData];
            }).join("text").attr("class", "all-available").attr("text-anchor", "middle").style("dominant-baseline", "middle").style("font-size", "1rem").style("font-weight", "bold").style("fill", "white").text(function (t) {
              return t.every(function (t) {
                return t.available;
              }) ? "100%" : "";
            }).style("fill-opacity", 0).transition().duration(2 * this.transitionDuration).style("fill-opacity", 1);
          }
        }]) && s(e.prototype, n), t;
      }();

      function c(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function f(t, e) {
        return f = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, f(t, e);
      }

      function h(t) {
        return h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, h(t);
      }

      var d = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && f(t, e);
        }(s, t);
        var e,
            n,
            a,
            i,
            l = (a = s, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = h(a);

          if (i) {
            var n = h(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return function (t, e) {
            return !e || "object" != _typeof(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });

        function s(t) {
          var e;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, s), (e = l.call(this, t)).svgWidth = t.width, e.svgHeight = t.height;
          var n = t.padding || 10;
          return e.svgPadding = {
            top: n,
            right: n,
            bottom: n,
            left: n
          }, e.height = e.svgHeight - e.svgPadding.top - e.svgPadding.bottom, e.width = e.svgWidth - e.svgPadding.left - e.svgPadding.right, e.availableColor = "#6c938b", e.unavailableColor = "#fec845", e.unknownColor = "#efefef", e.transitionDuration = 0, 1 == e.props.enableAnimations && (e.transitionDuration = 1e3), e;
        }

        return e = s, (n = [{
          key: "componentDidMount",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "drawChart",
          value: function value() {
            var t = o.select(this.svg).attr("viewBox", "0 0 " + this.svgWidth + " " + this.svgHeight).append("g").attr("transform", "translate(" + this.svgPadding.left + "," + this.svgPadding.top + ")");
            this.drawPie(t), this.drawChartLegend(t);
          }
        }, {
          key: "drawPie",
          value: function value(t) {
            var e = o.scaleBand().rangeRound([0, this.width]).paddingInner(.1).domain(this.props.data.map(function (t, e) {
              return e;
            })),
                n = Math.min(e.bandwidth() / 2, (this.height - 70) / 2),
                r = new u(this.props.data, {
              availableColor: this.availableColor,
              unavailableColor: this.unavailableColor,
              scale: e,
              radius: n,
              labelPadding: 35,
              transitionDuration: this.transitionDuration
            }),
                a = r.groupOn(t);
            r.drawOverlayText(a), a.each(function (t, r) {
              o.select(this).attr("transform", "translate(".concat(e(r) + e.bandwidth() / 2, ",").concat(n, ")"));
            });
          }
        }, {
          key: "drawChartLegend",
          value: function value(t) {
            var e = [{
              label: "Plant Available Nutrients",
              color: this.availableColor
            }, {
              label: "Plant Less Available Nutrients",
              color: this.unavailableColor
            }],
                n = t.selectAll("g.legend").data(e).join("g").attr("class", "legend");
            n.selectAll("rect").data(function (t) {
              return [t.color];
            }).join("rect").attr("x", 0).attr("y", -6).attr("width", 25).attr("height", 10).attr("stroke", "none").attr("fill", function (t) {
              return t;
            }), n.selectAll("text").data(function (t) {
              return [t.label];
            }).join("text").attr("x", 35).style("font-size", "0.8rem").style("font-weight", "bold").style("letter-spacing", "0.05rem").style("dominant-baseline", "middle").text(function (t) {
              return t;
            });
            var r = this.width,
                a = this.height;
            n.each(function (t, e) {
              var n = null;

              try {
                n = this.getBBox().width;
              } catch (t) {
                if (!t instanceof TypeError) throw t;
              }

              o.select(this).attr("transform", "translate(".concat(e * r - e * n, ",").concat(a - 5, ")"));
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this;
            return r().createElement("svg", {
              ref: function ref(e) {
                return t.svg = e;
              }
            });
          }
        }]) && c(e.prototype, n), s;
      }(r().Component);

      function p(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function v(t, e) {
        return v = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, v(t, e);
      }

      function g(t) {
        return g = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, g(t);
      }

      var y = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && v(t, e);
        }(s, t);
        var e,
            n,
            a,
            i,
            l = (a = s, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = g(a);

          if (i) {
            var n = g(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return function (t, e) {
            return !e || "object" != _typeof(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });

        function s(t) {
          var e;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, s), (e = l.call(this, t)).svgWidth = t.width, e.svgHeight = t.height;
          var n = t.padding || 10;
          return e.svgPadding = {
            top: n,
            right: n,
            bottom: n,
            left: n
          }, e.legendHeight = 40, e.height = e.svgHeight - e.svgPadding.top - e.svgPadding.bottom, e.width = e.svgWidth - e.svgPadding.left - e.svgPadding.right, e.availableColor = "#6c938b", e.unavailableColor = "#fec845", e.unknownColor = "#efefef", e.transitionDuration = 0, 1 == e.props.enableAnimations && (e.transitionDuration = 1e3), e;
        }

        return e = s, (n = [{
          key: "componentDidMount",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "drawChart",
          value: function value() {
            var t = o.select(this.svg).attr("viewBox", "0 0 " + this.svgWidth + " " + this.svgHeight).append("g").attr("transform", "translate(" + this.svgPadding.left + "," + this.svgPadding.top + ")");
            this.drawChartLegend(t), this.drawPie(t);
          }
        }, {
          key: "drawPie",
          value: function value(t) {
            var e = o.scaleBand().rangeRound([0, this.height - this.legendHeight]).paddingInner(.1).domain(this.props.data.map(function (t, e) {
              return e;
            })),
                n = Math.min((e.bandwidth() - 20) / 2, (this.width - 20) / 2),
                r = new u(this.props.data, {
              availableColor: this.availableColor,
              unavailableColor: this.unavailableColor,
              scale: e,
              radius: n,
              transitionDuration: this.transitionDuration
            }),
                a = r.groupOn(t);
            r.drawOverlayText(a);
            var i = this.width,
                l = this.legendHeight;
            a.each(function (t, n) {
              o.select(this).attr("transform", "translate(".concat(i / 2, ", ").concat(l + e(n) + e.bandwidth() / 2, ")"));
            });
          }
        }, {
          key: "drawChartLegend",
          value: function value(t) {
            var e = [{
              label: "Plant Available",
              color: this.availableColor
            }, {
              label: "Less Available",
              color: this.unavailableColor
            }],
                n = t.selectAll("g.legend").data(e).join("g").attr("class", "legend");
            n.selectAll("rect").data(function (t) {
              return [t.color];
            }).join("rect").attr("x", 0).attr("y", -6).attr("width", 25).attr("height", 10).attr("stroke", "none").attr("fill", function (t) {
              return t;
            }), n.selectAll("text").data(function (t) {
              return [t.label];
            }).join("text").attr("x", 35).style("font-size", "0.8rem").style("font-weight", "bold").style("letter-spacing", "0.05rem").style("dominant-baseline", "middle").text(function (t) {
              return t;
            });
            var r = 0,
                a = 0;
            n.each(function (t, e) {
              try {
                var n = this.getBBox();
                r = Math.max(r, n.width), a = Math.max(a, n.height);
              } catch (t) {
                if (!t instanceof TypeError) throw t;
              }
            });
            var i = this.width;
            n.each(function (t, e) {
              o.select(this).attr("transform", "translate(".concat((i - r) / 2, ",").concat((e + 1) * a, ")"));
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this;
            return r().createElement("svg", {
              ref: function ref(e) {
                return t.svg = e;
              }
            });
          }
        }]) && p(e.prototype, n), s;
      }(r().Component);

      function b(t, e) {
        if (t) {
          if ("string" == typeof t) return m(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(t, e) : void 0;
        }
      }

      function m(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }

        return r;
      }

      function w(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function P(t, e) {
        return P = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, P(t, e);
      }

      function x(t) {
        return x = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, x(t);
      }

      var C = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && P(t, e);
        }(s, t);
        var e,
            n,
            a,
            i,
            l = (a = s, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = x(a);

          if (i) {
            var n = x(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return function (t, e) {
            return !e || "object" != _typeof(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });

        function s(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, s), (e = l.call(this, t)).svgWidth = 600, e.svgHeight = 180, e.svgPadding = {
            top: 30,
            right: 30,
            bottom: 30,
            left: 30
          }, e.height = e.svgHeight - e.svgPadding.top - e.svgPadding.bottom, e.width = e.svgWidth - e.svgPadding.left - e.svgPadding.right, e.sectionCount = 100, e.valueColor = "#636464", e.labelOffsetFromDial = 30, e.gaugeThicknessPercent = .25, e.needleBaseRadiusPercentage = .07, e.transitionDuration = 0, 1 == e.props.enableAnimations && (e.transitionDuration = 1e3), e;
        }

        return e = s, (n = [{
          key: "componentDidMount",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.drawChart();
          }
        }, {
          key: "drawChart",
          value: function value() {
            var t,
                e,
                n = o.select(this.svg).attr("viewBox", "0 0 " + this.svgWidth + " " + this.svgHeight).append("g").attr("transform", "translate(" + this.svgPadding.left + "," + this.svgPadding.top + ")").selectAll("g.ratio-gauge").data(this.props.data).join("g").attr("class", "ratio-gauge"),
                r = (t = this.drawGauge(n), e = 2, function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

              if (null != n) {
                var r,
                    a,
                    i = [],
                    o = !0,
                    l = !1;

                try {
                  for (n = n.call(t); !(o = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); o = !0) {
                    ;
                  }
                } catch (t) {
                  l = !0, a = t;
                } finally {
                  try {
                    o || null == n["return"] || n["return"]();
                  } finally {
                    if (l) throw a;
                  }
                }

                return i;
              }
            }(t, e) || b(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()),
                a = r[0],
                i = r[1];
            this.drawNeedle(n, a - (a - i) / 2, a * this.needleBaseRadiusPercentage), this.drawLabel(n);
          }
        }, {
          key: "drawGauge",
          value: function value(t) {
            var e,
                n = o.scaleBand().rangeRound([0, this.width]).paddingInner(.1).domain(this.props.data.map(function (t, e) {
              return e;
            })),
                r = Math.min(n.bandwidth() / 2, this.width, this.height - this.labelOffsetFromDial),
                a = r - r * this.gaugeThicknessPercent,
                i = o.scaleLinear().domain([-Math.PI / 2, -Math.PI / 4, 0, Math.PI / 4, Math.PI / 2]).range(["#f2775e", "#fec845", "#6c938b", "#fec845", "#f2775e"]),
                l = o.scaleLinear().range([-Math.PI / 2, Math.PI / 2]).domain([0, this.sectionCount - 1]);
            return t.selectAll("path").data((e = Array(this.sectionCount), function (t) {
              if (Array.isArray(t)) return m(t);
            }(e) || function (t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(e) || b(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }())).join("path").attr("d", function (t, e) {
              return o.arc().outerRadius(r).innerRadius(a).startAngle(l(e - 1)).endAngle(l(e))();
            }).attr("fill", function (t, e) {
              return i(l(e));
            }).attr("stroke", function (t, e) {
              return i(l(e));
            }), t.each(function (t, e) {
              o.select(this).attr("transform", "translate(".concat(n(e) + n.bandwidth() / 2, ",").concat(r, ")"));
            }), [r, a];
          }
        }, {
          key: "drawNeedle",
          value: function value(t, e, n) {
            t.selectAll("circle.needle-center").data(function (t) {
              return [t.value];
            }).join("circle").attr("class", "needle-center").attr("cx", 0).attr("cy", 0).attr("r", n), t.selectAll("path.needle-body").data(function (t) {
              return [t.angle];
            }).join("path").attr("class", "needle-body").transition().ease(o.easeCircle).duration(this.transitionDuration).attrTween("d", function (t) {
              var r = o.interpolate(0, Math.min(Math.max(parseFloat(t), 0), Math.PI));
              return function (t) {
                return function (t, e, n) {
                  var r = Math.min(Math.max(parseFloat(t), 0), Math.PI),
                      a = 0 - e * Math.cos(r),
                      i = 0 - e * Math.sin(r);
                  return "M " + (0 - n * Math.cos(r - Math.PI / 2)) + " " + (0 - n * Math.sin(r - Math.PI / 2)) + " L " + a + " " + i + " L " + (0 - n * Math.cos(r + Math.PI / 2)) + " " + (0 - n * Math.sin(r + Math.PI / 2));
                }(r(t), e, n);
              };
            });
          }
        }, {
          key: "drawLabel",
          value: function value(t) {
            var e = t.selectAll("text.value").data(function (t) {
              return [t.value];
            }).join("text").attr("class", "value").attr("text-anchor", "middle").attr("y", this.labelOffsetFromDial).style("font-size", "1.2rem").style("letter-spacing", "0.05rem").attr("fill", this.valueColor);
            this.transitionDuration > 0 ? e.transition().ease(o.easeCircle).duration(this.transitionDuration).textTween(function (t) {
              var e = o.interpolateNumber(0, t);
              return function (t) {
                return (Math.round(100 * e(t)) / 100).toFixed(2);
              };
            }).on("end", function () {
              o.select(this).text(function (t) {
                return t;
              });
            }) : e.text(function (t) {
              return t;
            }), t.selectAll("text.label").data(function (t) {
              return [t.name];
            }).join("text").attr("class", "label").attr("text-anchor", "middle").attr("y", 45).style("font-size", "0.8rem").style("font-weight", "bold").style("letter-spacing", "0.05rem").text(function (t) {
              return t;
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this;
            return r().createElement("svg", {
              ref: function ref(e) {
                return t.svg = e;
              }
            });
          }
        }]) && w(e.prototype, n), s;
      }(r().Component);

      "undefined" != typeof window ? window.TNSReportsRAN = e : console.warn("Unable to register React components for TNS Reports RAN");
    }(), i;
  }();
});